module.exports = __webpack_public_path__ + "img/软件产品证书-城市运行管理系统V1.0.89cf397f.jpg";